import { Link } from "react-router-dom";
import Poster from "./Poster";

const POSTER_WIDTH = 120;
const POSTER_HEIGHT = 180;

const styles = {
    container: {
        display: "flex",
        flexDirection: "row",
        overflowX: "scroll",
        overflowY: "hidden",
        width: "100%",
    },
};

const MovieList = (props) => {
    const { items } = props;

    return (
        <div style={styles.container}>
            {items.length !== 0
                ? items.map((item) => (
                      <Movie key={item.ids.trakt} item={item} />
                  ))
                : [
                      <Poster
                          key={-1}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-2}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-3}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-4}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-5}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-6}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-7}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-8}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-9}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                      <Poster
                          key={-10}
                          width={POSTER_WIDTH}
                          height={POSTER_HEIGHT}
                      />,
                  ]}
        </div>
    );
};

const Movie = (props) => {
    const { item } = props;

    return (
        <Link to={`/movies/${item.ids.slug}`}>
            <Poster item={item} width={POSTER_WIDTH} height={POSTER_HEIGHT} />
        </Link>
    );
};

export default MovieList;
